type Context = 'app';

type Section =
  | 'configs'
  | 'home-page'
  | 'integration-token'
  | 'hubspot-visitor-api-token'
  | 'paragon-integrations'
  | 'paragon-crm-stats'
  | 'paragon-crm-tabs'
  | 'unlinked-status';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  configs: 'app-configs',
  'home-page': 'app-home-page',
  'integration-token': 'app-integration-token',
  'paragon-integrations': 'app-paragon-integrations',
  'hubspot-visitor-api-token': 'app-hubspot-visitor-api-token',
  'paragon-crm-stats': 'app-paragon-crm-stats',
  'paragon-crm-tabs': 'app-paragon-crm-tabs',
  'unlinked-status': 'app-unlinked-status',
};
